var render = function () {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        ((_obj = {}),
        (_obj[_vm.classNameDragging] = _vm.dragging),
        (_obj[_vm.classNameResizing] = _vm.resizing),
        (_obj[_vm.classNameDraggable] = _vm.draggable),
        (_obj[_vm.classNameResizable] = _vm.resizable),
        (_obj[_vm.classNameRotating] = _vm.rotating),
        (_obj[_vm.classNameRotatable] = _vm.rotatable),
        (_obj[_vm.classNameActive] = _vm.enabled),
        (_obj["linkageSetting"] = _vm.linkageActive),
        (_obj["batchSetting"] = _vm.batchOptActive),
        (_obj["drag-on-tab-collision"] = _vm.dragCollision),
        (_obj["positionChange"] = !(
          _vm.dragging ||
          _vm.resizing ||
          _vm.rotating
        )),
        _obj),
        _vm.className,
      ],
      style: _vm.style,
      on: {
        touchstart: _vm.elementTouchDown,
        mousedown: _vm.outerElementMouseDown,
        mouseenter: _vm.enter,
        mouseleave: _vm.leave,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.contentDisplay,
              expression: "contentDisplay",
            },
          ],
          class: [
            ((_obj$1 = {}),
            (_obj$1["de-drag-active-inner"] = _vm.enabled),
            (_obj$1[_vm.classNameMouseOn] = _vm.mouseOn || _vm.active),
            _obj$1),
            _vm.className,
          ],
          style: _vm.mainSlotStyle,
        },
        [
          _vm.editBarShow
            ? _c("edit-bar", {
                staticStyle: { transform: "translateZ(10px)" },
                attrs: {
                  "active-model": "edit",
                  "canvas-id": _vm.canvasId,
                  element: _vm.element,
                  chart: _vm.chart,
                  "series-id-map": _vm.seriesIdMap,
                },
                on: {
                  showViewDetails: _vm.showViewDetails,
                  amRemoveItem: _vm.amRemoveItem,
                  amAddItem: _vm.amAddItem,
                  resizeView: _vm.resizeView,
                  linkJumpSet: _vm.linkJumpSet,
                  boardSet: _vm.boardSet,
                },
              })
            : _vm._e(),
          _vm.mobileCheckBarShow
            ? _c("mobile-check-bar", {
                attrs: { element: _vm.element },
                on: { amRemoveItem: _vm.amRemoveItem },
              })
            : _vm._e(),
          _vm.resizing
            ? _c("div", {
                staticStyle: {
                  transform: "translateZ(11px)",
                  position: "absolute",
                  "z-index": "3",
                },
                style: _vm.resizeShadowStyle,
              })
            : _vm._e(),
          _vm._l(_vm.actualHandles, function (handlei, indexi) {
            return _c(
              "div",
              {
                key: indexi,
                class: [
                  _vm.classNameHandle,
                  _vm.classNameHandle + "-" + handlei,
                ],
                style: _vm.handleStyle(handlei, indexi),
                on: {
                  mousedown: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.handleDown(handlei, $event)
                  },
                  touchstart: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.handleTouchDown(handlei, $event)
                  },
                },
              },
              [_vm._t(handlei)],
              2
            )
          }),
          _c(
            "div",
            {
              staticClass: "main-background",
              style: _vm.mainSlotStyleInner,
              attrs: { id: _vm.componentCanvasId },
            },
            [
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !this.element.editing,
                    expression: "!this.element.editing",
                  },
                ],
                staticClass: "de-drag-area de-drag-top",
                on: { mousedown: _vm.elementMouseDown },
              }),
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !this.element.editing && this.element.type !== "de-tabs",
                    expression:
                      "!this.element.editing && this.element.type !=='de-tabs'",
                  },
                ],
                staticClass: "de-drag-area de-drag-right",
                on: { mousedown: _vm.elementMouseDown },
              }),
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !this.element.editing && this.element.type !== "de-tabs",
                    expression:
                      "!this.element.editing && this.element.type !=='de-tabs'",
                  },
                ],
                staticClass: "de-drag-area de-drag-bottom",
                on: { mousedown: _vm.elementMouseDown },
              }),
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !this.element.editing && this.element.type !== "de-tabs",
                    expression:
                      "!this.element.editing && this.element.type !=='de-tabs'",
                  },
                ],
                staticClass: "de-drag-area de-drag-left",
                on: { mousedown: _vm.elementMouseDown },
              }),
              _vm.svgInnerEnable
                ? _c("svg-icon", {
                    staticClass: "svg-background",
                    style: {
                      color: _vm.element.commonBackground.innerImageColor,
                    },
                    attrs: { "icon-class": _vm.mainSlotSvgInner },
                  })
                : _vm._e(),
              _vm._t("default"),
            ],
            2
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }